import { useEffect, useState } from "react";
import { BadgeDollarSign } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import axios, { API } from "@/lib/api";
import StatusBadge from "@/components/shared/StatusBadge";
import LoadingScreen from "@/components/shared/LoadingScreen";
import EmptyState from "@/components/shared/EmptyState";

function formatRp(n) { return `Rp ${Number(n || 0).toLocaleString("id-ID")}`; }
function formatDate(d) { return d ? new Date(d).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" }) : "-"; }

export default function AgentKomisi() {
  const [items, setItems] = useState(null);

  useEffect(() => {
    axios.get(`${API}/agen/komisi`).then(({ data }) => setItems(data)).catch(() => setItems([]));
  }, []);

  return (
    <div data-testid="agent-komisi-page" className="space-y-5">
      <div>
        <h1 className="font-heading text-2xl font-bold text-[#1F2937]">Riwayat Komisi</h1>
        <p className="text-sm text-[#64748B]">Komisi yang Anda dapatkan dari jamaah referral yang telah lunas membayar.</p>
      </div>

      {items === null ? <LoadingScreen /> : items.length === 0 ? (
        <EmptyState icon={BadgeDollarSign} title="Belum ada komisi" description="Komisi akan muncul di sini setelah jamaah referral Anda melunasi pembayaran." />
      ) : (
        <div className="overflow-x-auto rounded-xl border border-amber-100 bg-white">
          <Table data-testid="agent-komisi-table">
            <TableHeader><TableRow><TableHead>Program</TableHead><TableHead>Nilai Tagihan</TableHead><TableHead>Komisi</TableHead><TableHead>Status</TableHead><TableHead>Tanggal</TableHead></TableRow></TableHeader>
            <TableBody>
              {items.map((c) => (
                <TableRow key={c.id} data-testid={`agent-komisi-row-${c.id}`}>
                  <TableCell className="text-[#1F2937]">{c.program_name || "-"}</TableCell>
                  <TableCell className="text-[#64748B]">{formatRp(c.base_amount)}</TableCell>
                  <TableCell className="font-semibold text-[#0F6B4F]">{formatRp(c.total_commission)}</TableCell>
                  <TableCell><StatusBadge status={c.status === "paid" ? "paid" : "pending"} /></TableCell>
                  <TableCell className="text-[#64748B]">{formatDate(c.created_at)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      )}
    </div>
  );
}
